<template>
  <div class="col-sm-12" v-if="summary.Total.total >= 1">
    <div class="row totrow">
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">
            Total Calls
          </div>
          <div class="col-sm-12 cnt"> {{summary.Total.total}}
          </div>
        </div>
      </div>
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Air</div>
          <div class="col-sm-12 cnt">{{ summary.Air.total }}
          </div>
        </div>
      </div>
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Pollen</div>
          <div class="col-sm-12 cnt"> {{ summary.Pollen.total }}
          </div>
        </div>
      </div>
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Weather</div>
          <div class="col-sm-12 cnt">{{ summary.Weather.total }}
          </div>
        </div>
      </div>
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Soil</div>
          <div class="col-sm-12 cnt">{{ summary.Soil.total }}
          </div>
        </div>
      </div>
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Water</div>
          <div class="col-sm-12 cnt">{{ summary.Water_Vapour.total }}
          </div>
        </div>
      </div>
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">Fire</div>
          <div class="col-sm-12 cnt">{{ summary.Fire.total }}
          </div>
        </div>
      </div>
      <div class="col tot">
        <div class="row">
          <div class="col-sm-12 lbl">All</div>
          <div class="col-sm-12 cnt">{{ summary.All.total }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      summary: {},
      startVal: 0,
      endVal: 0,
      filterObj: {},
    };
  },
  props: ["start", "end", "day", "userTrans"],
  methods: {
    async totUsage() {
      // const apiUri = `http://localhost:3000/dashboard/total?start=${this.start}&end=${this.end}`;
      const apiUri = `http://13.235.254.91:5000/dashboard/total?start=${this.start}&end=${this.end}`;
      const options = {
        url: apiUri,
        method: "GET",
      };
      await this.$http(options)
        .then((result) => {
          this.summary = result.data;
        })
        .catch((e) => console.log("came to error", e));
    },
    userSummary(data) {
      this.summary = data;
    },
  },
  watch: {
    start: {
      immediate: true,
      handler(v) {
        if (v) this.totUsage();
      },
    },
    userTrans: {
      immediate: true,
      handler(v) {
        if (v) this.userSummary(v);
        else 
        {
            this.summary = []
        }
      },
    },
  },
};
</script>

<style scoped>
.totrow {
  display: inline-flex;
}
.cnt {
  font-size: 2rem;
}
.lbl {
  padding-top: 1.3rem;
  font-size: 0.9rem;
}
.tot {
  margin: 0.2rem;
  height: 6rem;
  color: white;
  text-align: center;
}
.tot:hover {
  font-size: 1.5rem;
}
.tot:nth-child(1) {
  color: #e91e63;
}
.tot:nth-child(2) {
  color: #3f51b5;
}
.tot:nth-child(3) {
  color: #28a745;
}
.tot:nth-child(4) {
  color: #a13764;
}
.tot:nth-child(5) {
  color: #743d2b;
}
.tot:nth-child(6) {
  color: #2295c8;
}
.tot:nth-child(7) {
  color: #ffb347;
}
.tot:nth-child(8) {
  color: #b2ad7f;
}
</style>